/**
 * Keeps checkout buttons and first-order minimum alerts in sync after cart updates.
 */
(function () {
	'use strict';

	function getConfig() {
		return window.TCP?.firstOrderMinimum;
	}

	function getCartTotal() {
		const cartJson = document.getElementById('cart-json');
		if (!cartJson) return 0;

		try {
			return JSON.parse(cartJson.textContent).total_price || 0;
		} catch (error) {
			return 0;
		}
	}

	function getItemCount() {
		const cartJson = document.getElementById('cart-json');
		if (!cartJson) return 0;

		try {
			return JSON.parse(cartJson.textContent).item_count || 0;
		} catch (error) {
			return 0;
		}
	}

	function shouldDisableCheckout() {
		const config = getConfig();
		if (!config?.enforce) return false;

		const cartTotal = getCartTotal();
		const itemCount = getItemCount();

		return itemCount === 0 || cartTotal < config.minimumCents;
	}

	function updateCheckoutState() {
		const config = getConfig();
		if (!config?.enforce) return;

		const disableCheckout = shouldDisableCheckout();

		document.querySelectorAll('.cart__checkout-button').forEach((button) => {
			button.disabled = disableCheckout;
			button.setAttribute('aria-disabled', disableCheckout ? 'true' : 'false');
		});

		document.querySelectorAll('[data-cart-minimum-alert]').forEach((alert) => {
			const itemCount = getItemCount();
			const meetsMinimum = getCartTotal() >= config.minimumCents;
			alert.hidden = itemCount === 0 || meetsMinimum;
		});
	}

	function blockCheckoutSubmit(event) {
		const submitter = event.submitter;
		if (!submitter || submitter.name !== 'checkout') return;
		if (!submitter.classList.contains('cart__checkout-button')) return;
		if (!shouldDisableCheckout()) return;

		event.preventDefault();
		event.stopPropagation();
	}

	function bindCheckoutForms() {
		document.querySelectorAll('#cart, #CartDrawer-Form').forEach((form) => {
			if (form.dataset.minimumOrderBound) return;
			form.dataset.minimumOrderBound = 'true';
			form.addEventListener('submit', blockCheckoutSubmit);
		});
	}

	function init() {
		updateCheckoutState();
		bindCheckoutForms();

		if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
			subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
				updateCheckoutState();
				bindCheckoutForms();
			});
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
